<template>
    <section id="home">
        <h2>首页导航</h2>

        <mt-tab-container v-model="active">
            <mt-tab-container-item id="tab-container1">
                <mt-cell v-for="(n, index) in 10" :key="index" title="tab-container 1"></mt-cell>
            </mt-tab-container-item>
            <mt-tab-container-item id="tab-container2">
                <mt-cell v-for="(n, index) in 5" :key="index" title="tab-container 2"></mt-cell>
            </mt-tab-container-item>
            <mt-tab-container-item id="tab-container3">
                <mt-cell v-for="(n, index) in 7" :key="index" title="tab-container 3"></mt-cell>
            </mt-tab-container-item>
        </mt-tab-container>

    </section>
</template>

<script>
    import { TabContainer, TabContainerItem } from 'mint-ui';

    export default {
            data(){
                return {
                    active:"tab-container3"
                }
            }
    }
</script>

<style lang="scss">
    #home{
        h2{
            text-align: center;
            font-size: 50px;
            line-height: 100px;
            background-image: linear-gradient(to right,rgba(0,191,255,0.4) 0%,rgba(0,0,255,0.4) 50%,rgba(0,191,255,0.4) 100%);
        }
    }

</style>